import m from "../../geodata/es2015/arubaHigh";
window.am4geodata_arubaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/arubaHigh.js
// module id = null
// module chunks = 